import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import map from 'lodash/map'

import useFormField from './useFormField'

const Select = ({
  label,
  helpText,
  className,
  controlClassName,
  labelClassName,
  fieldClassName,
  helpTextClassName,
  hideErrors,
  options,
  ...props
}) => {
  const {
    id,
    hasError,
    isDisabled,
    field,
    meta: {error},
  } = useFormField(props)

  const hasErrorToShow = !hideErrors && hasError

  const labelField = label ? (
    <label htmlFor={id} className={classNames('label', labelClassName)}>
      {label}
    </label>
  ) : null

  const inputProps = {
    ...field,
    ...props,
    id,
    disabled: isDisabled,
  }
  const selectContainerClassName = classNames('select', className, {
    'is-danger': hasErrorToShow,
  })
  const selectOptions = useMemo(
    () =>
      map(options, ({label, value}) => (
        <option key={value} value={value}>
          {label}
        </option>
      )),
    [options]
  )

  return (
    <div className={classNames('field', fieldClassName)}>
      {labelField}
      <div className={classNames('control', controlClassName)}>
        <div className={selectContainerClassName}>
          <select {...inputProps}>{selectOptions}</select>
        </div>
      </div>
      {hasErrorToShow ? <p className="help is-danger">{error}</p> : null}
      {helpText && (
        <p className={classNames('help', helpTextClassName)}>{helpText}</p>
      )}
    </div>
  )
}

Select.defaultProps = {
  hideErrors: false,
}

Select.propTypes = {
  className: PropTypes.string,
  controlClassName: PropTypes.string,
  fieldClassName: PropTypes.string,
  helpText: PropTypes.node,
  helpTextClassName: PropTypes.string,
  hideErrors: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.node,
  labelClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  type: PropTypes.string,
}

export default Select
